/* unplugin-vue-components disabled */import { render } from "./SortingQuestionEdit.vue?vue&type=template&id=48668c45&scoped=true&ts=true"
import script from "./SortingQuestionEdit.vue?vue&type=script&lang=ts"
export * from "./SortingQuestionEdit.vue?vue&type=script&lang=ts"

import "./SortingQuestionEdit.vue?vue&type=style&index=0&id=48668c45&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48668c45"]])

export default __exports__